import { GLOBAL_BLOCK_UI, GLOBAL_RELEASE_UI } from "../constants";
import { Dispatch } from "redux";

export const blockUI = () => (dispatch: Dispatch) => {
  dispatch({ type: GLOBAL_BLOCK_UI });
};

export const releaseUI = () => (dispatch: Dispatch) => {
  dispatch({ type: GLOBAL_RELEASE_UI });
};
